import { Dialog, Button, Stack, Typography, useTheme } from '@mui/material'
import React from 'react'

export const DeleteSubmissionModal = ({ open, onClose, onConfirm, loading }) => {
  const theme = useTheme()

  return (
    <Dialog open={open} onClose={onClose}>
      <Stack style={{ padding: 24, minWidth: 300 }}>
        <Typography variant="h4" component="h2">
          Delete Submission
        </Typography>
        <Typography variant="body1" sx={{ mt: 1 }}>
          Do you really want to delete this submission? This action
          <strong><span style={{ color: theme.palette.error.main }}> cannot be undone.</span></strong>
        </Typography>

        <Stack direction="row" style={{ display: 'flex', justifyContent: 'flex-end', gap: 8, marginTop: 24 }}>
          <Button
            onClick={onClose}
            color="primary"
            variant="outlined"
            disabled={loading}
            sx={{
              '&:hover': {
                backgroundColor: theme => theme.palette.primary[200]
              }
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={onConfirm}
            color="error"
            variant="contained"
            disabled={loading}
            sx={{
              '&:hover': {
                backgroundColor: theme => theme.palette.error[800]
              }
            }}
          >
            Delete
          </Button>
        </Stack>
      </Stack>
    </Dialog>
  )
}
